import React, { useRef, useEffect, useState } from 'react';

const ScrollableFilter = ({ children, className }) => {
    const containerRef = useRef(null);
    const [isScrollable, setIsScrollable] = useState(false);

    useEffect(() => {
        // Proveri da li sadržaj prelazi širinu kontejnera
        const checkScrollable = () => {
            if (containerRef.current) {
                setIsScrollable(containerRef.current.scrollWidth > containerRef.current.clientWidth);
            }
        };

        checkScrollable(); // Proveri pri inicijalizaciji
        window.addEventListener('resize', checkScrollable); // Ponovo proveri pri promeni veličine prozora
        return () => window.removeEventListener('resize', checkScrollable); // Ukloni listener
    }, []);

    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;

    // Mouse events
    const handleMouseDown = (e) => {
        if (!isScrollable) return;
        isDragging = true;
        startX = e.pageX - containerRef.current.offsetLeft;
        scrollLeft = containerRef.current.scrollLeft;
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - containerRef.current.offsetLeft;
        const walk = (x - startX) * 2; // Adjust scroll speed
        containerRef.current.scrollLeft = scrollLeft - walk;
    };

    const handleMouseUp = () => {
        isDragging = false;
    };

    // Touch events
    const handleTouchStart = (e) => {
        if (!isScrollable) return;
        startX = e.touches[0].pageX - containerRef.current.offsetLeft;
        scrollLeft = containerRef.current.scrollLeft;
    };

    const handleTouchMove = (e) => {
        if (!isScrollable) return;
        e.preventDefault();
        const x = e.touches[0].pageX - containerRef.current.offsetLeft;
        const walk = (x - startX) * 2; // Adjust scroll speed
        containerRef.current.scrollLeft = scrollLeft - walk;
    };

    return (
        <div
            className={`scrollable-filter ${className || ''}`}
            ref={containerRef}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleMouseUp}
            style={{
                display: 'flex',
                justifyContent: isScrollable ? 'flex-start' : 'center', // Centrirano ako nije skrolabilno
                alignItems: 'center',
                overflowX: 'auto',
                whiteSpace: 'nowrap',
                scrollBehavior: 'smooth',
                paddingBottom: '5px',
                paddingLeft: isScrollable ? '20px' : '0', // Dodaj razmak samo kada je skrolabilno
            }}
        >
            {children}
        </div>
    );
};

export default ScrollableFilter;
